const streamSignals = {
    capabilities: "getRouterRtpCapabilities",
    producer: {
        create: "createProducerTransport",
        connect: "connectProducerTransport",
        register: "registerStream",
        updateThumbnail: "updateThumbnail",
        produce: "produce",
        stop: 'stopStream'
    },
    consumer: {
        create: "createConsumerTransport",
        connect: "connectConsumerTransport",
        consume: "consume"
    }
};

export default streamSignals;